/** Remember where the user was (v1 reicrm_view parity): the current page and any
 * open detail record, so a browser refresh returns to the same spot instead of
 * bouncing to the default page. sessionStorage-backed ON PURPOSE — it is PER-TAB,
 * so two tabs/windows each keep their OWN view across a refresh (localStorage is
 * shared, which made refreshing one tab jump it to the other tab's page). Survives
 * refresh; a brand-new tab starts at the default. Best-effort — private mode /
 * disabled storage just no-ops. */
export interface SavedView {
  page: string;
  /** open deal detail (natKey), if the transaction detail was open */
  deal?: string | null;
  /** open lead detail (address), if the property drawer was open */
  lead?: string | null;
  /** open wholesale detail (natKey), if that drawer was open */
  wholesale?: string | null;
  /** the deal drawer's inner tab (v1 _TT0 parity: refresh lands on the SAME
   * tab — Expenses stays Expenses, not back to Purchasing) */
  dealTab?: string | null;
  /** the Rehab tab's inner sub-tab (details | sow | photos) — refresh on SOW
   * must come back to SOW, not bounce to Details */
  dealSub?: string | null;
  /** the property drawer's inner tab */
  leadTab?: string | null;
}

const KEY = "crm2_view";

export function loadView(): SavedView | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as unknown;
    if (v && typeof v === "object" && typeof (v as SavedView).page === "string") {
      return v as SavedView;
    }
  } catch { /* corrupt / disabled storage */ }
  return null;
}

export function saveView(v: SavedView): void {
  try {
    const out: SavedView = { page: v.page };
    if (v.deal) out.deal = v.deal;
    if (v.lead) out.lead = v.lead;
    if (v.wholesale) out.wholesale = v.wholesale;
    if (v.deal && v.dealTab) out.dealTab = v.dealTab;
    if (v.deal && v.dealSub) out.dealSub = v.dealSub;
    if (v.lead && v.leadTab) out.leadTab = v.leadTab;
    sessionStorage.setItem(KEY, JSON.stringify(out));
  } catch { /* private mode — skip */ }
}
